import { Button, Group } from "@mantine/core";

interface HeldEmailConfirmButtonsProps {
  actionLabel: string;
  cancelLabel: string;
  color?: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function HeldEmailConfirmButtons(props: HeldEmailConfirmButtonsProps) {
  const { actionLabel, cancelLabel, color, loading, onClose, onConfirm } =
    props;
  return (
    <Group justify="space-between">
      <Button onClick={onClose} variant="default">
        {cancelLabel}
      </Button>
      <Button color={color} loading={loading} onClick={onConfirm}>
        {actionLabel}
      </Button>
    </Group>
  );
}
